import { Box,Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAppTheme } from "../../../context/ThemeContext";

export default function AdminTeamInfo(){
  const [searchParams]=useSearchParams();
  const {colors,typography,shape}=useAppTheme();
  const category=searchParams.get("category")||"";

  return (
    <Box
      sx={{
        p:2,
        border:`1px solid ${colors.border}`,
        borderRadius:shape.radiusLarge,
        backgroundColor:colors.surface
      }}
    >
      <Typography sx={{fontSize:typography.sizes.lg,fontWeight:700,color:colors.text}}>
        Información
      </Typography>

      <Typography sx={{mt:0.5,fontSize:typography.sizes.sm,color:colors.textSecondary}}>
        Aquí se mostrará la información adicional del equipo{category?` dentro de la categoría ${category}`:""}.
      </Typography>
    </Box>
  );
}